// extracted by mini-css-extract-plugin
export default {"Error-page":"error-page-component_Error-page__tH9HN","Error-page__card-wrapper":"error-page-component_Error-page__card-wrapper__MmfYY"};